import cn from 'classnames'
import { ReactNode } from 'react'

import { CloseIcon } from './CloseIcon'
import styles from './ProfileAvatarsPopup.module.scss'

type Props = {
  children: ReactNode
  isOpen: boolean
  onClose: () => void
}

export const ProfileAvatarsPopup = ({ children, isOpen, onClose }: Props) => {
  return (
    <div
      className={cn(styles.popup, {
        [styles.open]: isOpen,
      })}
      onClick={onClose}
    >
      <div className={styles.content} onClick={(e) => e.stopPropagation()}>
        <span className={styles.closeIcon} onClick={onClose}>
          <CloseIcon />
        </span>
        {children}
      </div>
    </div>
  )
}
